/* eslint quote-props: ["error", "as-needed", { "keywords": true, "unnecessary": false }] */

import ERROR_CODES from '@/constants/error-codes';

const TERMS_OF_USE = `
  I accept the terms and provisions of the
  <a href="https://legal.motmom.com/documents/license" target="_blank"/>User Agreement</a> and
  agree that LLC Mo.Card will process my personal data
  as public data in accordance with Federal Law No.152-FZ on Personal Data
  dated 27.07.2006, on the terms and for the purposes stipulated by the
  <a href="https://legal.motmom.com/documents/privacy" target="_blank">Personal data processing and protection policy</a>. I agree to receive
  informational, advertising and other messages
`;

export default {
  authorize_title: 'AUTHORIZATION',
  sign_out_title: 'SIGN OUT',
  registration_title: 'REGISTRATION',
  password_restoration_title: 'PASSWORD RESTORATION',
  card_activation_title: 'ACTIVATION <span style="color: #ccc;">MO.</sapn><span style="color: #707070;">CARD</sapn>',
  activation_title: 'ACTIVATION',

  input_subtitle: 'Enter',
  password_change_subtitle: 'Your new password',
  email_verification_subtitle: 'Email',
  code_verification_subtitle: {
    phone: 'Code from sms',
    email: 'Code from email',
  },
  card_activation_subtitle: 'Enter Mo.Card number',

  incorrect_login: {
    login: 'Login incorrect',
    email: 'Email incorrect',
    phone: 'Phone incorrect',
  },

  cant_be_empty: 'The field cannot be empty',
  must_be_accepted: 'This field should be accepted',
  multilogin_placeholder_full: 'Phone number or email address',
  multilogin_placeholder_small: 'Phone number or email',

  RatingPasswordTitle: '',
  weakRatingPasswordTitle: 'Weak password.',
  mediumRatingPasswordTitle: 'Medium password.',
  strongRatingPasswordTitle: 'Strong password.',

  changePasswordDescription: {
    title: 'We recommend to use:',
    length: 'at least 8 characters',
    numbers: 'numbers',
    lowercase: 'lowercase letters',
    uppercase: 'uppercase letters',
    symbols: 'special symbols',
  },

  sign_in: 'Sign In',
  sign_out: 'Sign Out',
  next: 'Next',
  cancel: 'Cancel',
  allow: 'Allow',
  change: 'Change',
  restration_submit: 'Sign up',
  get_new_code: 'Get new code',
  code_accepted: 'Code accepted',

  second_name: 'SECOND NAME',
  name: 'NAME',
  patronymic: 'PATRONYMIC',
  email: 'EMAIL',
  phone: 'PHONE',
  city: 'CITY',
  country: 'COUNTRY',

  password: 'Password',
  forgot_password: 'Forgot password?',
  remember_me: 'Remember me',
  correct_the_mistake: 'Correct form errors',
  incorrect_login_or_password: 'Incorrect login or password',
  incorrect_email: 'Incorrect email',
  error_on_server: 'An unexpected error has been occurred',
  need_select_date: 'You must select a date',
  not_found: 'No matches found',

  authorize_footer_text: {
    please_authorize: 'Please sign in. ',
    if_no: 'If you don\'t have a ',
    profile: ' profile yet, ',
    registter: ' register ',
    or: ' or ',
    activate_card: ' activate your Mo.Card.',
  },

  email_and_phone_verification_text: 'After entering your email or phone number and requesting a code, you will receive an email or sms with a code, which must be confirmed in a future form of the page.',
  email_verification_text: 'After entering your email address and pressing the "Next" button, you will get an email with a code to fill out in the next step',
  code_verification_text: 'An email with a code was sent to the email you provided',
  request_new_code_avilible: 'You can get a new code in',
  email_verification_success_text: 'All right! ',
  email_verification_go_to_registration: 'Go to registration.',
  email_verification_go_to_restoration: 'Go to restoration.',

  card_activation_text: {
    less_two_minutes: 'Activation will not take you more than 2 minutes',
    already_activated: 'Already activated a card?',
    sign_in: ' Sign in ...',
    input_activation_code: 'Enter activation code',
    your_card_has_been_activated: 'Your Mo.Card is activated!',
    wrong_code: ' - wrong code',
    code_on_card: 'The activation code is on the back of your Mo.card',
    all_right: 'All right! Go to registration',
  },

  skip_activation: {
    link_name: 'Skip and sign up without Mo.Card',
    can_bind_card_anytime: 'You can bind Mo.Card at any time in personal account.',
  },

  activation_registration_text: {
    success_now_register: 'Successful activation of Mo.Card! Now, registration.',
    enter_email: 'Enter your email',
  },

  authorize_success: {
    success: 'Sign In successfully completed! ',
    will_be_redirect: 'You will be redirected to ',
  },

  sign_out_success: {
    success: 'Sign Out successfully completed! ',
    will_be_redirect: 'You will be redirected to ',
  },

  oauth2_success: {
    success: 'Permissions have been granted!',
    will_be_redirect: 'You will be redirected to ',
  },

  registration_success: {
    success: 'Registration completed successfully! ',
    wellcome: 'Welcome to Motmom - discounts and Magic Points in Your favorite places of Your city.',
    will_be_redirect: 'You will be redirected to  ',
  },

  restore_success: {
    success: 'Password successfully restored! ',
    will_be_redirect: 'You will be redirected to ',
  },

  birthday: {
    title: 'DATE OF BIRTH',
    year: 'Year',
    month: 'Month',
    day: 'Day',
  },

  genders: {
    female: 'W',
    male: 'M',
  },

  authTermsOfUse: `<span style="line-height: 20px;  color: gray;">
    Pressing the button Sign in, ${TERMS_OF_USE} on the specified during
    authorization mobile phone number and email address.</span>
  `,

  initialTermsOfUse: `<span style="line-height: 20px;  color: gray;">
  Pressing the button Next, ${TERMS_OF_USE} on the specified during
  registration mobile phone number and email address.</span>
`,

  termsOfUse: `<span style="line-height: 20px;  color: gray;">
  Pressing the button Sign up, ${TERMS_OF_USE} on the specified during
  registration mobile phone number and email address.</span>
`,

  oauth2_change_account: 'Change account',
  oauth2_title: {
    access: 'Allow the  ',
    use_account: ' application to use your account?',
  },

  oauth2_policy: {
    i_confirm: ' I agree to the transfer of this information from the owner of the resource motmom.com to the owner of the ',
    i_also_confirm: ' application. I also give my consent to the subsequent processing of personal data by the owner of the ',
    i_realize: ' application. I understand that the specified resource is a publicly available source of information, and I consent to the processing of data taking into account the specified feature of the resource. The processing of personal data and revocation of consent to the processing of personal data is carried out under the terms of the resource privacy policies.',
    i_full_confirm: 'I have read and fully agree with their terms.',
    i_conset_personal_data_transfer: ['I give my consent to the transfer of my mobile phone number and email address in order to receive from the owner of the ', ' application information, advertising and other messages to the specified mobile phone number and e-mail address.'],
  },

  cookie_notice_text: {
    header: 'USE OF COOKIES',
    we_use_cookie: 'We use cookies that are essential for our website to function properly. Also, our website and third-party companies Google and Yandex use analytical cookies to analyze the audience and its behavior. You can find out more about our cookie policy by clicking the "Details" button.',
    if_you_accept: 'If you agree to the use of all cookies, click "Accept all". Use the "Accept necessary" button if you are against of analytical cookies.',
    accept_all: 'Accept all',
    accept_necessary: 'Accept necessary',
    more_info: 'Details',
  },

  cookie_policy_text: {
    use_cooki_files: 'Cookie Policy',
    necessary_cookie: 'Necessary cookies',
    policy_about_cookie_files: 'Cookie Policy',
    about_necessary_cookie: 'Necessary cookies include basic features such as security and accessibility. You can disable them by changing your browser settings, but this may affect how the site works. ',
    we_use_next_necessary_cookie: 'We use the following necessary (technical) cookies:',
    necessary_cookie_list: [
      {
        cookie: 'cookies_usage_confirmation, is_additional_cookies_accepted',
        description: 'these cookies contain information about the user\'s choice regarding the use of cookies or the user\'s will not to make a choice.',
      },
      {
        cookie: 'MOSSID',
        description: 'these cookies contain information intended for authentication in the service.',
      },
    ],
    analytics_cookie: 'Analytics cookies',
    why_analytics: 'We and our partners use analytical cookies to help us improve our website by collecting and reporting information about how you use it. Cookies collect information in such a way that we cannot identify you. The information obtained using such cookies is available to third parties, in particular, Yandex. ',
    we_use_next_analytics_cookie: 'We use the following analytics cookies:',
    analytics_cookie_list: [
      {
        cookie: 'IDE',
        description: 'this cookie contains information about how the end user uses the website and any advertisements that the end user may have seen prior to visiting the said website.',
      },
      {
        cookie: '_ym_d',
        description: 'this cookie is associated with Yandex Metrica and contains the date the user first visited the site.',
      },
      {
        cookie: '_ym_isad',
        description: 'this cookie is associated with Yandex Metrica and determines whether the user has an ad blocker enabled or not.',
      },
      {
        cookie: '_ym_uid',
        description: 'This cookie is associated with Yandex Metrica. This cookie is used to identify unique users by assigning a randomly generated number as a customer ID. ',
      },
      {
        cookie: '_ym_visorc_XXXXXXXX',
        description: 'this cookie is associated with Yandex Metrica and contains the webviewer\'s identifier and allows session playback to work correctly.',
      },
      {
        cookie: 'i; yandexuid ',
        description: 'This cookie is associated with Yandex Metrica. This cookie allows you to distinguish between visitors. ',
      },
      {
        cookie: 'yabs-sid',
        description: 'This cookie is associated with Yandex Metrica. This cookie is used as a visit identifier. ',
      },
      {
        cookie: 'yp',
        description: 'this cookie is associated with Yandex Metrica, This cookie is used as a container for storing portal data of a persistent nature.',
      },
      {
        cookie: 'ys',
        description: 'This cookie is associated with Yandex Metrica. This cookie is used as a container for storing the session data of the portal. ',
      },
      {
        cookie: 'mda',
        description: 'This cookie is associated with Yandex Metrica. This cookie is used for multi-domain authentication. ',
      },
      {
        cookie: 'ymex',
        description: 'This cookie is associated with Yandex Metrica. This cookie is used for advertising, helps to distinguish users, is used to analyze platforms and sites, to measure and analyze web traffic. ',
      },
      {
        cookie: 'yuidss',
        description: 'This cookie is associated with Yandex Metrica. This cookie collects information about the behavior of visitors across multiple sites. This information I am used on the site to optimize the relevance of advertisements. ',
      },
    ],
    more_about_cookie_policy: 'For more information on how we handle cookies, please see the <a href="https://legal.motmom.com/documents/privacy" style="color: gray;"> Privacy Policy. </a> ',
    control_policy_of_analitycs_cookie: 'Manage analytic cookie settings',
    i_agree: 'I consent to the collection of analytical cookies',
    i_degree: 'I do not consent to the collection of analytical cookies',
    save_button_text: 'Save my settings',
    select_error: 'Nothing selected',
  },

  errors_messages: {
    [ERROR_CODES.MISSING_USER]: 'Missing user.',
    [ERROR_CODES.TOO_MANY_REQUESTS]: 'Too many requests.',
    [ERROR_CODES.TOO_MANY_ATTEMPTS]: 'You have exceeded the maximum number of attempts. Try again later.',
    [ERROR_CODES.INVALID_UNIQUE_KEY]: 'Invalid unique key. Try again later.',
    [ERROR_CODES.INVALID_VERIFICATION_CODE]: 'Verification code is invalid or expired.',
    [ERROR_CODES.MIXED_PARAMS]: 'Mixed parameters of SMS-code and unique key.',
    [ERROR_CODES.INVALID_PASSWORD]: 'Invalid password.',
    [ERROR_CODES.EMAIL_NOT_CONFIRMED]: 'This email address is not confirmed. You could try to recover your account with your phone number or contact Technical Support.',
    [ERROR_CODES.ERROR_ATTEMPT_LIMIT]: 'Too many attempts, try later',

    [ERROR_CODES.INVALID_CARD_NUMBER]: 'Mo.Card with this number does not exist.',
    [ERROR_CODES.ERROR_CARD_ALREADY_ACTIVATED]: 'Mo.Card with this number is already activated.',
    [ERROR_CODES.INVALID_ACTIVATION_CODE]: 'Invalid activation code',
    [ERROR_CODES.INVALID_SMS_CODE]: 'Invalid code',
    [ERROR_CODES.ERROR_EMAIL_SENDING_TIMEOUT]: 'Too many attempts. Please try again later.',
    [ERROR_CODES.INVALID_BIRTHDAY]: 'Invalid birthday',

    [ERROR_CODES.INVALID_IDENTIFIER]: 'Invalid phone number or email address',
    [ERROR_CODES.ERROR_INVALID_EMAIL]: 'Invalid email address',
    [ERROR_CODES.ERROR_EMAIL_EXISTS]: 'This email address is already taken',
    [ERROR_CODES.ERROR_INVALID_PASSWORD]: 'Invalid password',
    [ERROR_CODES.UNKNOWN_SERVER_ERROR]: 'An unknown error has occurred. Refresh the page and perform the action again or contact support.',

    [ERROR_CODES.INVALID_USER_OR_PASSWORD]: 'Invalid user or password',
    [ERROR_CODES.USER_NOT_FOUND]: 'User not found',
    [ERROR_CODES.USER_IS_BLOCKED]: 'User is blocked',
    [ERROR_CODES.PHONE_EXISTS]: 'Phone number already exists',
    [ERROR_CODES.PASSWORD_RESTORATION_REQUIRED]: 'Password restoration required',
    [ERROR_CODES.EMAIL_SENDER_ERROR]: 'Error sending email with recovery code. Please try later',
    [ERROR_CODES.ERROR_EMAIL_OR_PASSWORD_NOT_FOUND]: 'Email or password are not correct',
    [ERROR_CODES.ERROR_PHONE_NUMBER_OR_PASSWORD_NOT_FOUND]: 'Phone number or password are not correct',
    [ERROR_CODES.ERROR_CARD_NUMBER_OR_PASSWORD_NOT_FOUND]: 'Card number or password are not correct',
    [ERROR_CODES.ERROR_INVALID_USERNAME]: 'Invalid username',
  },

  country_name: {
    'AF': 'Afghanistan',
    'AL': 'Albania',
    'DZ': 'Algeria',
    'AS': 'American Samoa',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AQ': 'Antarctica',
    'AG': 'Antigua and Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaijan',
    'BS': 'Bahamas',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BY': 'Belarus',
    'BE': 'Belgium',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BM': 'Bermuda',
    'BT': 'Bhutan',
    'BO': 'Bolivia',
    'BA': 'Bosnia and Herzegovina',
    'BW': 'Botswana',
    'BV': 'Bouvet Island',
    'BR': 'Brazil',
    'IO': 'British Indian Ocean Territory',
    'BN': 'Brunei Darussalam',
    'BG': 'Bulgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'KH': 'Cambodia',
    'CM': 'Cameroon',
    'CA': 'Canada',
    'CV': 'Cape Verde',
    'KY': 'Cayman Islands',
    'CF': 'Central African Republic',
    'TD': 'Chad',
    'CL': 'Chile',
    'CN': 'China',
    'CX': 'Christmas Island',
    'CC': 'Cocos (Keeling) Islands',
    'CO': 'Colombia',
    'KM': 'Comoros',
    'CG': 'Congo',
    'CD': 'Congo, the Democratic Republic of the',
    'CK': 'Cook Islands',
    'CR': 'Costa Rica',
    'CI': 'Cote D\'Ivoire',
    'HR': 'Croatia',
    'CU': 'Cuba',
    'CY': 'Cyprus',
    'CZ': 'Czech Republic',
    'DK': 'Denmark',
    'DJ': 'Djibouti',
    'DM': 'Dominica',
    'DO': 'Dominican Republic',
    'EC': 'Ecuador',
    'EG': 'Egypt',
    'SV': 'El Salvador',
    'GQ': 'Equatorial Guinea',
    'ER': 'Eritrea',
    'EE': 'Estonia',
    'ET': 'Ethiopia',
    'FK': 'Falkland Islands (Malvinas)',
    'FO': 'Faroe Islands',
    'FJ': 'Fiji',
    'FI': 'Finland',
    'FR': 'France',
    'GF': 'French Guiana',
    'PF': 'French Polynesia',
    'TF': 'French Southern Territories',
    'GA': 'Gabon',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'DE': 'Germany',
    'GH': 'Ghana',
    'GI': 'Gibraltar',
    'GR': 'Greece',
    'GL': 'Greenland',
    'GD': 'Grenada',
    'GP': 'Guadeloupe',
    'GU': 'Guam',
    'GT': 'Guatemala',
    'GN': 'Guinea',
    'GW': 'Guinea-Bissau',
    'GY': 'Guyana',
    'HT': 'Haiti',
    'HM': 'Heard Island and McDonald Islands',
    'VA': 'Holy See (Vatican City State)',
    'HN': 'Honduras',
    'HK': 'Hong Kong',
    'HU': 'Hungary',
    'IS': 'Iceland',
    'IN': 'India',
    'ID': 'Indonesia',
    'IR': 'Iran, Islamic Republic of',
    'IQ': 'Iraq',
    'IE': 'Ireland',
    'IL': 'Israel',
    'IT': 'Italy',
    'JM': 'Jamaica',
    'JP': 'Japan',
    'JO': 'Jordan',
    'KZ': 'Kazakhstan',
    'KE': 'Kenya',
    'KI': 'Kiribati',
    'KP': 'North Korea',
    'KR': 'South Korea',
    'KW': 'Kuwait',
    'KG': 'Kyrgyzstan',
    'LA': 'Lao People\'s Democratic Republic',
    'LV': 'Latvia',
    'LB': 'Lebanon',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libya',
    'LI': 'Liechtenstein',
    'LT': 'Lithuania',
    'LU': 'Luxembourg',
    'MO': 'Macao',
    'MG': 'Madagascar',
    'MW': 'Malawi',
    'MY': 'Malaysia',
    'MV': 'Maldives',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Marshall Islands',
    'MQ': 'Martinique',
    'MR': 'Mauritania',
    'MU': 'Mauritius',
    'YT': 'Mayotte',
    'MX': 'Mexico',
    'FM': 'Micronesia, Federated States of',
    'MD': 'Moldova, Republic of',
    'MC': 'Monaco',
    'MN': 'Mongolia',
    'MS': 'Montserrat',
    'MA': 'Morocco',
    'MZ': 'Mozambique',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Netherlands',
    'NC': 'New Caledonia',
    'NZ': 'New Zealand',
    'NI': 'Nicaragua',
    'NE': 'Niger',
    'NG': 'Nigeria',
    'NU': 'Niue',
    'NF': 'Norfolk Island',
    'MK': 'North Macedonia, Republic of',
    'MP': 'Northern Mariana Islands',
    'NO': 'Norway',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palestine',
    'PA': 'Panama',
    'PG': 'Papua New Guinea',
    'PY': 'Paraguay',
    'PE': 'Peru',
    'PH': 'Philippines',
    'PN': 'Pitcairn',
    'PL': 'Poland',
    'PT': 'Portugal',
    'PR': 'Puerto Rico',
    'QA': 'Qatar',
    'RE': 'Reunion',
    'RO': 'Romania',
    'RU': 'Russian Federation',
    'AC': 'Ascension island',
    'RW': 'Rwanda',
    'SH': 'Saint Helena',
    'KN': 'Saint Kitts and Nevis',
    'LC': 'Saint Lucia',
    'PM': 'Saint Pierre and Miquelon',
    'VC': 'Saint Vincent and the Grenadines',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'Sao Tome and Principe',
    'SA': 'Saudi Arabia',
    'SN': 'Senegal',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapore',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'SB': 'Solomon Islands',
    'SO': 'Somalia',
    'ZA': 'South Africa',
    'GS': 'South Georgia and the South Sandwich Islands',
    'ES': 'Spain',
    'LK': 'Sri Lanka',
    'SD': 'Sudan',
    'SR': 'Suriname',
    'SJ': 'Svalbard and Jan Mayen',
    'SZ': 'Eswatini',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'SY': 'Syrian Arab Republic',
    'TW': 'Taiwan',
    'TJ': 'Tajikistan',
    'TZ': 'Tanzania, United Republic of',
    'TH': 'Thailand',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TO': 'Tonga',
    'TT': 'Trinidad and Tobago',
    'TN': 'Tunisia',
    'TR': 'Turkey',
    'TM': 'Turkmenistan',
    'TC': 'Turks and Caicos Islands',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraine',
    'AE': 'United Arab Emirates',
    'GB': 'United Kingdom',
    'US': 'United States of America',
    'UM': 'United States Minor Outlying Islands',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistan',
    'VU': 'Vanuatu',
    'VE': 'Venezuela',
    'VN': 'Vietnam',
    'VG': 'Virgin Islands, British',
    'VI': 'Virgin Islands, U.S.',
    'WF': 'Wallis and Futuna',
    'EH': 'Western Sahara',
    'YE': 'Yemen',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe',
    'AX': 'Åland Islands',
    'BQ': 'Bonaire, Sint Eustatius and Saba',
    'CW': 'Curaçao',
    'GG': 'Guernsey',
    'IM': 'Isle of Man',
    'JE': 'Jersey',
    'ME': 'Montenegro',
    'BL': 'Saint Barthélemy',
    'MF': 'Saint Martin (French part)',
    'RS': 'Serbia',
    'SX': 'Sint Maarten (Dutch part)',
    'SS': 'South Sudan',
    'XK': 'Kosovo',
  },
};
